(() => {
  function init(root) {
    if (root.dataset.enhanced) return;
    const form = root.querySelector('form');
    const select = root.querySelector('[data-variant-select]');
    const variants = JSON.parse(root.querySelector('[data-brkox-variants]').textContent);
    const strings = JSON.parse(root.querySelector('[data-brkox-strings]').textContent);
    const button = root.querySelector('[data-add-button]');
    const label = root.querySelector('[data-add-label]');
    const quantity = root.querySelector('[data-quantity]');
    const mainImage = root.querySelector('.brkox-pdp__main-image');
    const dialog = root.querySelector('[data-image-dialog]');
    const stickyButton = root.querySelector('[data-sticky-add]');
    const thumbnails = Array.from(root.querySelectorAll('[data-image-thumb]'));
    const fullscreenGallery = dialog?.hasAttribute('data-gallery-fullscreen');
    const galleryCount = root.querySelector('[data-gallery-count]');
    let syncMobileGallery = () => {};
    let previousOverflow;
    let busy = false;
    function showImage(src, alt) {
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = src;
      if (alt) mainImage.alt = alt;
      const selected = thumbnails.find(thumb => thumb.dataset.imageSrc === src);
      const fullSrc = fullscreenGallery ? selected?.dataset.imageFull || src : src;
      root.querySelector('[data-image-open]')?.setAttribute('href', fullSrc);
      const zoomImage = dialog.querySelector('img');
      if (zoomImage) { zoomImage.removeAttribute('srcset'); zoomImage.src = fullSrc; zoomImage.alt = mainImage.alt; }
      if (fullscreenGallery) {
        thumbnails.forEach(thumb => {
          if (thumb === selected) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        if (galleryCount) galleryCount.textContent = `${Math.max(0, thumbnails.indexOf(selected)) + 1} / ${Math.max(1, thumbnails.length)}`;
        syncMobileGallery(Math.max(0, thumbnails.indexOf(selected)));
      }
    }
    function updateVariant(updateUrl) {
      const variant = variants.find(item => String(item.id) === select.value);
      if (!variant) return;
      root.querySelector('[data-product-price]').textContent = variant.price;
      root.querySelector('[data-sticky-price]').textContent = variant.price;
      const compare = root.querySelector('[data-product-compare]');
      compare.textContent = variant.compare;
      compare.hidden = !variant.on_sale;
      root.querySelector('[data-product-availability]').textContent = variant.available ? strings.available : strings.sold_out;
      button.disabled = !variant.available || busy;
      stickyButton.disabled = !variant.available || busy;
      label.textContent = busy ? strings.adding : variant.available ? strings.add : strings.sold_out;
      stickyButton.textContent = variant.available ? strings.add : strings.sold_out;
      const accelerated = root.querySelector('[data-accelerated]');
      if (accelerated) accelerated.hidden = !variant.available;
      root.querySelectorAll('[data-variant-choice]').forEach(choice => { if (choice.dataset.variantId === select.value) choice.setAttribute('aria-current', 'true'); else choice.removeAttribute('aria-current'); });
      if (variant.image) showImage(variant.image);
      root.querySelector('[data-cart-error]').hidden = true;
      if (updateUrl) { const url = new URL(window.location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url.toString()); }
      form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
    }
    root.querySelectorAll('[data-variant-choice]').forEach(choice => choice.addEventListener('click', event => {
      event.preventDefault();
      select.value = choice.dataset.variantId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    select.addEventListener('change', () => updateVariant(true));
    root.querySelector('[data-quantity-minus]').addEventListener('click', () => { quantity.value = Math.max(1, (Number(quantity.value) || 1) - 1); quantity.dispatchEvent(new Event('change', { bubbles: true })); });
    root.querySelector('[data-quantity-plus]').addEventListener('click', () => { quantity.value = Math.max(1, (Number(quantity.value) || 1) + 1); quantity.dispatchEvent(new Event('change', { bubbles: true })); });
    quantity.addEventListener('change', () => { quantity.value = Math.max(1, Math.floor(Number(quantity.value) || 1)); });
    root.querySelectorAll('[data-image-thumb]').forEach(thumb => thumb.addEventListener('click', event => {
      event.preventDefault();
      showImage(thumb.dataset.imageSrc, thumb.dataset.imageAlt);
      root.querySelectorAll('[data-image-thumb]').forEach(item => item.removeAttribute('aria-current'));
      thumb.setAttribute('aria-current', 'true');
    }));
    root.querySelector('[data-image-open]')?.addEventListener('click', event => {
      if (typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (dialog.open) return;
      if (fullscreenGallery) {
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        const selected = thumbnails.find(thumb => thumb.getAttribute('aria-current') === 'true');
        if (selected) showImage(selected.dataset.imageSrc, selected.dataset.imageAlt);
      }
      dialog.showModal();
    });
    root.querySelector('[data-image-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    if (fullscreenGallery) {
      const moveImage = direction => {
        if (thumbnails.length < 2) return;
        const index = Math.max(0, thumbnails.findIndex(thumb => thumb.getAttribute('aria-current') === 'true'));
        thumbnails[(index + direction + thumbnails.length) % thumbnails.length].click();
      };
      root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => moveImage(-1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => moveImage(1));
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        moveImage(event.key === 'ArrowLeft' ? -1 : 1);
      });
      dialog.addEventListener('close', () => {
        if (previousOverflow !== undefined) document.documentElement.style.overflow = previousOverflow;
        previousOverflow = undefined;
      });
      const enableSwipe = surface => {
        if (!surface || thumbnails.length < 2) return;
        let start;
        let ignoreClickUntil = 0;
        surface.addEventListener('dragstart', event => event.preventDefault());
        surface.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || event.target.closest('button')) { start = undefined; return; }
          start = { x: event.clientX, y: event.clientY, id: event.pointerId };
        });
        surface.addEventListener('pointercancel', () => { start = undefined; });
        surface.addEventListener('pointerup', event => {
          if (!start || start.id !== event.pointerId) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          start = undefined;
          if (Math.abs(dx) < 44 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
          ignoreClickUntil = Date.now() + 500;
          moveImage(dx < 0 ? 1 : -1);
        });
        surface.addEventListener('click', event => {
          if (Date.now() >= ignoreClickUntil || event.detail === 0 || event.target.closest('button')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, true);
      };
      enableSwipe(root.querySelector('[data-image-open]'));
      enableSwipe(root.querySelector('[data-gallery-swipe]'));
      const mobileGallery = root.querySelector('[data-mobile-gallery]');
      if (mobileGallery) {
        const slides = Array.from(mobileGallery.querySelectorAll('[data-mobile-image-open]'));
        const mobileCount = root.querySelector('[data-mobile-gallery-count]');
        const mobileQuery = window.matchMedia('(max-width: 749px)');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let scrollingFromGallery = false;
        let scrollFrame = 0;
        let drag;
        let ignoreClickUntil = 0;
        const updateMobileCount = index => {
          if (mobileCount) mobileCount.textContent = `${index + 1} / ${slides.length}`;
          slides.forEach((slide, slideIndex) => {
            if (slideIndex === index) slide.setAttribute('aria-current', 'true');
            else slide.removeAttribute('aria-current');
          });
          const thumb = thumbnails[index];
          const strip = root.querySelector('[data-thumbnail-strip]');
          if (thumb && strip && strip.clientWidth) {
            const left = thumb.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft;
            if (left < strip.scrollLeft || left + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) {
              strip.scrollTo({ left: Math.max(0, left - (strip.clientWidth - thumb.offsetWidth) / 2), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
            }
          }
        };
        syncMobileGallery = index => {
          updateMobileCount(index);
          if (!mobileQuery.matches || scrollingFromGallery || !mobileGallery.clientWidth) return;
          const left = index * mobileGallery.clientWidth;
          if (Math.abs(mobileGallery.scrollLeft - left) > 1) {
            mobileGallery.scrollTo({ left, behavior: reducedMotion.matches || dialog.open ? 'instant' : 'smooth' });
          }
        };
        const selectMobileImage = index => {
          if (!slides[index]) return;
          scrollingFromGallery = true;
          showImage(slides[index].dataset.imageSrc, slides[index].querySelector('img')?.alt);
          updateMobileCount(index);
          scrollingFromGallery = false;
        };
        mobileGallery.addEventListener('scroll', () => {
          if (scrollFrame) return;
          scrollFrame = requestAnimationFrame(() => {
            scrollFrame = 0;
            if (!mobileQuery.matches || !mobileGallery.clientWidth) return;
            const index = Math.max(0, Math.min(slides.length - 1, Math.round(mobileGallery.scrollLeft / mobileGallery.clientWidth)));
            if (slides[index]?.getAttribute('aria-current') !== 'true') selectMobileImage(index);
          });
        }, { passive: true });
        slides.forEach((slide, index) => slide.addEventListener('click', event => {
          if (typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          if (event.detail !== 0 && Date.now() < ignoreClickUntil) return;
          selectMobileImage(index);
          root.querySelector('[data-image-open]').click();
        }));
        mobileGallery.addEventListener('dragstart', event => event.preventDefault());
        mobileGallery.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          drag = { x: event.clientX, y: event.clientY, left: mobileGallery.scrollLeft, id: event.pointerId, horizontal: false };
        });
        mobileGallery.addEventListener('pointermove', event => {
          if (!drag || drag.id !== event.pointerId) return;
          const dx = event.clientX - drag.x;
          const dy = event.clientY - drag.y;
          if (!drag.horizontal && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.25) {
            drag.horizontal = true;
            mobileGallery.classList.add('is-dragging');
            mobileGallery.setPointerCapture(event.pointerId);
          }
          if (!drag.horizontal) return;
          event.preventDefault();
          mobileGallery.scrollLeft = drag.left - dx;
        });
        const finishDrag = event => {
          if (!drag || drag.id !== event.pointerId) return;
          const horizontal = drag.horizontal;
          drag = undefined;
          mobileGallery.classList.remove('is-dragging');
          if (mobileGallery.hasPointerCapture(event.pointerId)) mobileGallery.releasePointerCapture(event.pointerId);
          if (!horizontal) return;
          ignoreClickUntil = Date.now() + 500;
          const index = Math.max(0, Math.min(slides.length - 1, Math.round(mobileGallery.scrollLeft / mobileGallery.clientWidth)));
          mobileGallery.scrollTo({ left: index * mobileGallery.clientWidth, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
          selectMobileImage(index);
        };
        mobileGallery.addEventListener('pointerup', finishDrag);
        mobileGallery.addEventListener('pointercancel', finishDrag);
        const alignMobileGallery = () => {
          if (!mobileQuery.matches) return;
          const index = Math.max(0, thumbnails.findIndex(thumb => thumb.getAttribute('aria-current') === 'true'));
          mobileGallery.scrollTo({ left: index * mobileGallery.clientWidth, behavior: 'instant' });
          updateMobileCount(index);
        };
        mobileQuery.addEventListener('change', alignMobileGallery);
        if ('ResizeObserver' in window) new ResizeObserver(alignMobileGallery).observe(mobileGallery);
        root.setAttribute('data-mobile-gallery-ready', '');
        requestAnimationFrame(alignMobileGallery);
      }
    }
    stickyButton.addEventListener('click', () => { if (!busy) form.requestSubmit(button); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => { root.toggleAttribute('data-sticky-active', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(button);
    }
    form.addEventListener('submit', async event => {
      const cart = document.querySelector('cart-drawer');
      if (!cart || typeof cart.renderContents !== 'function' || typeof cart.getSectionsToRender !== 'function') return;
      event.preventDefault();
      if (busy || button.disabled) return;
      busy = true;
      updateVariant(false);
      const error = root.querySelector('[data-cart-error]');
      try {
        const body = new FormData(form);
        body.delete('brkox_variant_choice');
        body.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        body.set('sections_url', window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
        const route = window.Shopify?.routes?.root || '/';
        const response = await fetch(route + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || strings.error);
        cart.classList.remove('is-empty');
        cart.renderContents(result, true);
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: result }));
      } catch (failure) {
        error.textContent = failure instanceof TypeError ? strings.error : failure.message || strings.error;
        error.hidden = false;
      } finally {
        busy = false;
        const variant = variants.find(item => String(item.id) === select.value);
        button.disabled = !variant?.available;
        stickyButton.disabled = !variant?.available;
        label.textContent = variant?.available ? strings.add : strings.sold_out;
      }
    });
    root.dataset.enhanced = 'true';
    updateVariant(false);
  }
  function initAll() { document.querySelectorAll('[data-brkox-product]').forEach(init); }
  initAll();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
